import { DAPI_HOST } from '../../config/index';

const getFoundHelpfulUrl = (solvRatingId: any) =>
  `${DAPI_HOST}/v1/solv-ratings/${solvRatingId}/found-helpful`;

export { getFoundHelpfulUrl };
